import { createSlice } from '@reduxjs/toolkit';
import { get } from 'state/thunks/reportYear';

const initialState = {
    response: [],
    loading: false,
    success: false,
    error: null
}

const reportYearSlice = createSlice({
    name: 'reportYear',
    initialState,
    reducers: {
        clear: () => initialState
    },
    extraReducers: builder => {
        builder.addCase(get.pending, state => {
            state.loading = true
        })

        builder.addCase(get.fulfilled, (state, action) => {
            state.response = action.payload
            state.loading = false
            state.success = true
            state.error = null
        })

        builder.addCase(get.rejected, (state, action) => {
            state.loading = false
            state.success = false
            state.error = action.payload
        })
    }
})

export const actions = {
    ...reportYearSlice.actions,
    get
}

export const reducer = reportYearSlice.reducer;
